import React, { useState } from 'react';
import { useWmsProgressByDestinationQuery } from '../../hooks/useWmsProgressQuery';
import { WmsProgressTable, OrderStatus } from './WmsProgressTable';
import { WmsProgressFilterInput } from '../../graphql/queries/getWmsProgress';
import IndicatorCard from 'components/IndicatorCard';
import OrderListDrawer from './OrderListDrawer';
import { useTranslation } from 'react-i18next';

interface ByDestinationTabProps {
  appliedFilters: WmsProgressFilterInput;
}

const ByDestinationTab: React.FC<ByDestinationTabProps> = ({ appliedFilters }) => {
  const { t } = useTranslation();
  const {
    progressData,
    loading
  } = useWmsProgressByDestinationQuery(appliedFilters);

  // 递归计算总行数（包括所有层级的行）
  const countTotalRows = (data: typeof progressData): number => {
    let count = 0;
    data.forEach(item => {
      count += 1; // 当前行
      if (item.children && item.children.length > 0) {
        count += countTotalRows(item.children);
      }
    });
    return count;
  };

  const totalRows = countTotalRows(progressData);

  // 抽屉状态管理
  const [drawerState, setDrawerState] = useState({
    open: false,
    sortingCode: '',
    status: 'total' as OrderStatus,
    level: ''
  });

  // 处理表格数值点击事件
  const handleCellClick = (sortingCode: string, status: OrderStatus, level: string) => {
    setDrawerState({
      open: true,
      sortingCode,
      status,
      level
    });
  };

  // 关闭抽屉
  const handleDrawerClose = () => {
    setDrawerState(prev => ({
      ...prev,
      open: false
    }));
  };

  return (
    <>
      {/* 进度卡片 */}
      <IndicatorCard
        title={t('wms.progress.title')}
        items={[
          {
            label: t('wms.progress.label.baggedTotalInWHS'),
            value: `${(() => {
              const packSum = progressData.reduce((sum: number, item) => sum + (item.packNum || 0), 0);
              const totalSum = progressData.reduce((sum: number, item) => sum + (item.total || 0), 0);
              return totalSum === 0 ? 'N/A' : `${(packSum / totalSum * 100).toFixed(2)}%`;
            })()}`,
            alignment: 'left',
          }
        ]}
      />

      {/* 统计表格 */}
      <WmsProgressTable
        progressData={progressData}
        loading={loading}
        onCellClick={handleCellClick}
      />

      {/* 合计 */}
      <div className="flex justify-between items-center">
        <div className="text-gray-500">
          {t('table.pagination.totalItems', { total: totalRows })}
        </div>
      </div>

      {/* 订单列表抽屉 */}
      <OrderListDrawer
        open={drawerState.open}
        onClose={handleDrawerClose}
        sortingCode={drawerState.sortingCode}
        status={drawerState.status}
        level={drawerState.level}
        currentFilters={appliedFilters}
      />
    </>
  );
};

export default ByDestinationTab;

